import styled from 'styled-components';
import { Alert } from '@mui/material';

import { ReactComponent as AlertIcon } from '../../../../../assets/icons/menuIcons/feedMenuIcons/special-reminders.svg';
import colors from '../../../../../styles/colors';
import { PrimaryButton } from '../../../../../components/Button/ActionButtons';

const StyledAlert = styled(Alert)`
  align-items: center;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  padding: 0px 20px;
  ${({ $isLeadsAvailable }) => $isLeadsAvailable && `
    background-color: ${colors.shades.primary7};
    border: 1.5px solid ${colors.base.primary};
  `}
`;

const StyledButton = styled(PrimaryButton)`
  margin-left: 15px;
`;

const StyledAlertIcon = styled(AlertIcon)`
  height: 24px;
  width: 24px;
  > path {
    stroke: ${colors.shades.danger3};
  }
`;

export {
  StyledAlert,
  StyledButton,
  StyledAlertIcon,
};
